$.fn.autoPadding = function ($settings) {
  var $config = {
      source: null
    },
    $target = $(this);
  var navMenu = $('#js-nav-menu');
  var windowWidth = $(window).width();
  if ($settings) jQuery.extend($config, $settings);
  $(this).css({
    paddingTop: $config.source.innerHeight() + 'px'
  });
  $(window).resize(function () {
    if ($(window).width() != windowWidth) {
      windowWidth = $(window).width();
      if (!navMenu.hasClass('is-fixed-top')) {
        $target.css({
          paddingTop: $config.source.innerHeight() + 'px'
        });
      }
    }
  });
};


// WEBPACK FOOTER //
// ./scripts/util/autoPadding.js